import VueDragscroll from "vue-dragscroll";

export default function (app) {
    app.use(VueDragscroll);
}
